<template>
  <v-container fluid v-if="organization" class="px-12 py-4">
    <v-row>
      <v-col cols="12">
        <breadcrumbs></breadcrumbs>
        <h1>DCW for Trizetto</h1>
        <v-divider class="my-3"></v-divider>
      </v-col>
    </v-row>

    <v-alert dense type="info" outlined>
      Click fields to copy text to clipboard
    </v-alert>

    <div class="px-2 mt-8">
      <v-row>
        <v-col :sm="3" class="och-grid--header">Practice Name</v-col>
        <v-col :sm="3" class="och-grid--header">Contact Name & Title</v-col>
        <v-col :sm="1" class="och-grid--header">Phone</v-col>
        <v-col :sm="1" class="och-grid--header">Fax</v-col>
        <v-col :sm="2" class="och-grid--header">Email</v-col>
        <v-col :sm="2" class="och-grid--header">Tax ID</v-col>
      </v-row>
      <v-row>
        <v-col :sm="3" class="och-grid--cell">
          <text-copier :value="organization.name"></text-copier>
        </v-col>
        <v-col :sm="3" class="och-grid--cell">
          <text-copier
            :value="organization.billingClaimsEnrollmentContactPerson"
          ></text-copier>
        </v-col>
        <v-col :sm="1" class="och-grid--cell">
          <text-copier
            :value="organization.billingClaimsEnrollmentContactPhone"
          ></text-copier>
        </v-col>
        <v-col :sm="1" class="och-grid--cell">
          <text-copier
            :value="organization.billingPatientStatementFaxNumber"
          ></text-copier>
        </v-col>
        <v-col :sm="2" class="och-grid--cell">
          <text-copier
            :value="organization.billingClaimsEnrollmentContactEmail"
          ></text-copier>
        </v-col>
        <v-col :sm="2" class="och-grid--cell">
          <text-copier :value="organization.billingClaimsTaxId"></text-copier>
        </v-col>
      </v-row>

      <v-row>
        <v-col :sm="3" class="och-grid--header">Current Client - Site ID</v-col>
      </v-row>
      <v-row>
        <v-col :sm="3" class="och-grid--cell">
          {{ organization.billingClaimsTrizettoSiteId }}
        </v-col>
      </v-row>

      <div class="caption font-weight-bold mt-4 ml-n2">
        SERVICE LOCATION ADDRESS
      </div>

      <v-row>
        <v-col :sm="3" class="och-grid--header">Street Address</v-col>
        <v-col :sm="3" class="och-grid--header">City</v-col>
        <v-col :sm="1" class="och-grid--header">State</v-col>
        <v-col :sm="1" class="och-grid--header">Zip + 4</v-col>
        <v-col :sm="2" class="och-grid--cellBlank"></v-col>
        <v-col :sm="2" class="och-grid--header">Sharable TaxID?</v-col>
      </v-row>
      <v-row v-if="mainAddress">
        <v-col :sm="3" class="och-grid--cell">
          <text-copier :value="mainAddress.address"></text-copier>
        </v-col>
        <v-col :sm="3" class="och-grid--cell">
          <text-copier :value="mainAddress.city"></text-copier>
        </v-col>
        <v-col :sm="1" class="och-grid--cell">
          <text-copier :value="mainAddress.state"></text-copier>
        </v-col>
        <v-col :sm="1" class="och-grid--cell och-gridCap--border">
          <text-copier :value="mainAddress.zip"></text-copier>
        </v-col>
        <v-col :sm="2" class="och-grid--cellBlank"></v-col>
        <v-col :sm="2" class="och-grid--cell">
          <text-copier
            :value="organization.billingClaimsTaxIdSharedYN ? 'Yes' : 'No'"
          ></text-copier>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col :sm="12">
          <v-alert>There is no address defined for the organization</v-alert>
        </v-col>
      </v-row>

      <div class="caption font-weight-bold mt-4 ml-n2">PAY-TO ADDRESS</div>

      <v-row>
        <v-col :sm="3" class="och-grid--header">Street Address</v-col>
        <v-col :sm="3" class="och-grid--header">City</v-col>
        <v-col :sm="1" class="och-grid--header">State</v-col>
        <v-col :sm="1" class="och-grid--header">Zip + 4</v-col>
        <v-col :sm="2" class="och-grid--cellBlank"></v-col>
        <v-col :sm="2" class="och-grid--header">Group NPI</v-col>
      </v-row>
      <v-row v-if="payToAddress">
        <v-col :sm="3" class="och-grid--cell">
          <text-copier :value="payToAddress.address"></text-copier>
        </v-col>
        <v-col :sm="3" class="och-grid--cell">
          <text-copier :value="payToAddress.city"></text-copier>
        </v-col>
        <v-col :sm="1" class="och-grid--cell">
          <text-copier :value="payToAddress.state"></text-copier>
        </v-col>
        <v-col :sm="1" class="och-grid--cell och-gridCap--border">
          <text-copier :value="payToAddress.zip"></text-copier>
        </v-col>
        <v-col :sm="2" class="och-grid--cellBlank"></v-col>
        <v-col :sm="2" class="och-grid--cell">
          <text-copier
            :value="organization.billingClaimsGroupNPI"
          ></text-copier>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col :sm="12">
          <v-alert
            >There is no pay-to address defined for the organization</v-alert
          >
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col :sm="3" class="och-grid--header">Go Live Date</v-col>
        <v-col :sm="5" class="och-grid--header">Claims Types</v-col>
        <v-col :sm="2" class="och-grid--cellBlank"></v-col>
        <v-col :sm="2" class="och-grid--header">Specialty</v-col>
      </v-row>
      <v-row>
        <v-col :sm="3" class="och-grid--cell"
          >To be inserted by billing analyst.</v-col
        >
        <v-col :sm="5" class="och-grid--cell och-gridCap--border">
          <text-copier
            :value="
              organization.billingClaimsTypes
                ? organization.billingClaimsTypes.join(', ')
                : '--'
            "
          ></text-copier>
        </v-col>
        <v-col :sm="2" class="och-grid--cellBlank"></v-col>
        <v-col :sm="2" class="och-grid--cell">
          <text-copier :value="organization.specialty"></text-copier>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col :sm="2" class="och-grid--header">Provider Count</v-col>
        <v-col :sm="2" class="och-grid--header">Number of Locations</v-col>
        <v-col :sm="2" class="och-grid--header">Current Clearinghouse</v-col>
        <v-col :sm="2" class="och-grid--header">Go Live Date</v-col>
        <v-col :sm="2" class="och-grid--cellBlank"></v-col>
        <v-col :sm="2" class="och-grid--header">Parent Site</v-col>
      </v-row>
      <v-row>
        <v-col :sm="2" class="och-grid--cell">
          <text-copier
            :value="organization.billingClaimsNumberOfProviders"
          ></text-copier>
        </v-col>
        <v-col :sm="2" class="och-grid--cell">
          <text-copier :value="locationCount"></text-copier>
        </v-col>
        <v-col :sm="2" class="och-grid--cell">
          <text-copier
            :value="organization.billingClaimsClearinghouse"
          ></text-copier>
        </v-col>
        <v-col :sm="2" class="och-grid--cell och-gridCap--border"
          >To be inserted by billing analyst.</v-col
        >
        <v-col :sm="2" class="och-grid--cellBlank"></v-col>
        <v-col :sm="2" class="och-grid--cell">
          <text-copier :value="mainAddress.state"></text-copier>
        </v-col>
      </v-row>

      <div class="caption font-weight-bold mt-4 ml-n2">PRODUCT INFORMATION</div>

      <v-row>
        <v-col :sm="3" class="och-grid--header">Claims Package</v-col>
        <v-col :sm="3" class="och-grid--header">E-Statements</v-col>
        <v-col :sm="1" class="och-grid--header">EOB Conversion</v-col>
        <v-col :sm="1" class="och-grid--header">Pat. Pay Conv.</v-col>
        <v-col :sm="2" class="och-grid--header">Correspondence Conv.</v-col>
        <v-col :sm="2" class="och-grid--header">276/277 RT Claim Status</v-col>
      </v-row>
      <v-row>
        <v-col :sm="3" class="och-grid--cell">
          <text-copier
            :value="
              organization.billingClaimsTrizettoServicesInterest
                ? organization.billingClaimsTrizettoServicesInterest.join(', ')
                : '--'
            "
          ></text-copier>
        </v-col>
        <v-col :sm="3" class="och-grid--cell"></v-col>
        <v-col :sm="1" class="och-grid--cell"></v-col>
        <v-col :sm="1" class="och-grid--cell"></v-col>
        <v-col :sm="2" class="och-grid--cell"></v-col>
        <v-col :sm="2" class="och-grid--cell"></v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import cloneDeep from "lodash/cloneDeep";
import moment from "moment";
import Breadcrumbs from "@/views/Breadcrumbs";
import TextCopier from "@/components/static/TextCopier";

export default {
  components: {
    Breadcrumbs,
    TextCopier,
  },
  computed: {
    ...mapState({
      addressRecord: state => state.address.record,
      locationList: state => state.location.list,
      organizationRecord: state => state.organization.record,
      organizationId: state => state.session.organizationId,
    }),
    locationCount() {
      if (this.locationList) {
        return this.locationList.length;
      }
      return "--";
    },
  },
  async created() {
    await this.getOrganization(this.organizationId);
    this.organization = cloneDeep(this.organizationRecord);
    if (this.organization.addressId) {
      await this.getAddress(this.organization.addressId);
      this.mainAddress = cloneDeep(this.addressRecord);
    }
    if (this.organization.billingClaimsPayToAddress) {
      await this.getAddress(this.organization.billingClaimsPayToAddress);
      this.payToAddress = cloneDeep(this.addressRecord);
    }
    await this.getLocationList();
  },
  data() {
    return {
      mainAddress: {},
      organization: {},
      payToAddress: {},
    };
  },
  methods: {
    ...mapActions({
      getAddress: "address/get",
      getLocationList: "location/list",
      getOrganization: "organization/getByOrganizationId",
    }),
    formatDate(date) {
      return moment.utc(date).format("MMMM DD, YYYY");
    },
  },
};
</script>

<style>
.och-grid--header {
  background-color: var(--v-primary-base) !important;
  color: white;
  font-size: 12px;
  font-weight: bold;
  height: 28px !important;
  overflow: hidden;
  padding-top: 4px !important;
  text-align: center;
  white-space: nowrap;
}
.och-grid--cell {
  border-bottom: 1px solid var(--v-primary-base) !important;
  border-left: 1px solid var(--v-primary-base) !important;
  border-right: 0px solid white;
  overflow: hidden;
  padding: 2px 5px !important;
  text-overflow: ellipsis;
  min-height: 20px;
}
.och-grid--cell:last-child,
.och-gridCap--border {
  border-right: 1px solid var(--v-primary-base) !important;
}
.och-grid--cellBlank {
  background-color: transparent;
  border: 0;
}
</style>
